// Translation strings - English + simple spoken Tamil
export const translations = {
  en: {
    app_name: "GT Royal Beedi & Matches",
    // Auth
    welcome: "Welcome",
    login: "Login",
    phone: "Phone Number",
    pin: "Enter 4-digit PIN",
    enter_phone: "Enter your phone",
    invalid_login: "Wrong phone or PIN",
    logout: "Logout",
    choose_language: "Choose Language",
    // Common
    dashboard: "Dashboard",
    orders: "Orders",
    products: "Products",
    submit: "Submit",
    cancel: "Cancel",
    confirm: "Confirm",
    save: "Save",
    edit: "Edit",
    delete: "Delete",
    back: "Back",
    next: "Next",
    today: "Today",
    total: "Total",
    amount: "Amount",
    quantity: "Quantity",
    units: "Boxes",
    boxes: "Boxes",
    box: "Box",
    total_boxes: "Total Boxes",
    pending_boxes: "Pending Boxes",
    delivered_boxes: "Delivered Boxes",
    stock_boxes: "Stock Boxes",
    available_boxes: "Available Boxes",
    box_price: "Box Price",
    boxes_sold: "Boxes Sold",
    loading: "Loading…",
    yes: "Yes",
    no: "No",
    search: "Search",
    // Shopkeeper
    place_order: "Place Order",
    my_orders: "My Orders",
    profile: "Profile",
    select_products: "Select Products",
    add: "Add",
    remove: "Remove",
    cart: "Cart",
    payment_method: "Payment Method",
    cash: "Cash",
    upi: "UPI",
    pay_on_upi: "Pay via UPI",
    upi_id: "UPI ID",
    upload_screenshot: "Upload Screenshot (optional)",
    i_paid: "I Paid",
    repeat_order: "Repeat Same Order",
    no_orders: "No orders yet",
    order_placed: "Order placed successfully!",
    order_date: "Order Date",
    items: "Items",
    status: "Status",
    // Salesman
    todays_orders: "Today's Orders",
    delivered_today: "Delivered",
    pending: "Pending",
    units_sold: "Boxes Sold",
    sales: "Sales",
    cash_collected: "Cash Collected",
    upi_collected: "UPI Collected",
    start_delivery: "Start Delivery",
    mark_delivered: "Mark Delivered",
    photo_proof: "Upload Photo Proof",
    take_photo: "Take Photo",
    enter_amount: "Enter Amount",
    delivery_done: "Delivery Complete",
    // Order statuses
    s_pending: "Pending",
    s_assigned: "Assigned",
    s_out_for_delivery: "Out for Delivery",
    s_delivered: "Delivered",
    s_cancelled: "Cancelled",
    high_priority: "High Priority",
    // Manager
    assigned: "Assigned",
    assign: "Assign",
    assign_salesman: "Assign Salesman",
    salesmen: "Salesmen",
    reassign: "Reassign",
    salesman_performance: "Salesman Performance",
    // Management
    company_performance: "Company Performance",
    district_performance: "District Performance",
    cash_vs_upi: "Cash vs UPI",
    last_7_days: "Last 7 Days",
    // Admin
    users: "Users",
    districts: "Districts",
    beats: "Beats",
    bulk_upload: "Bulk Upload",
    upi_pending: "UPI Pending",
    verify: "Verify",
    add_user: "Add User",
    add_product: "Add Product",
    add_district: "Add District",
    name: "Name",
    role: "Role",
    district: "District",
    region: "Region",
    price: "Price",
    sku: "SKU",
    shop_name: "Shop Name",
    address: "Address",
    upload_csv: "Upload CSV",
    paid: "Paid",
    cash_to_collect: "Cash to Collect",
    your_name: "Your Name",
    welcome_back: "Welcome back",
    not_registered: "Phone number not registered",
    close: "Close",
    offer: "Offer",
    scheme: "Scheme",
    popups: "Popups",
    filters: "Filters",
    clear_filters: "Clear",
    apply: "Apply",
    all: "All",
    date_range: "Date Range",
    from: "From",
    to: "To",
    map_view: "Map View",
    route_map: "Route Map",
    no_locations: "No delivery locations yet",
    notifications: "Notifications",
    no_notifications: "No notifications",
    mark_all_read: "Mark all read",
    audit_logs: "Audit Logs",
    assignment_history: "Assignment History",
    offline: "Offline",
    pending_sync: "Pending sync",
    synced: "Synced",
    payment_status: "Payment Status",
    // Direct Sale
    direct_sale: "Direct Sale",
    new_direct_sale: "New Direct Sale",
    sales_history: "Sales History",
    walk_in: "Walk-in",
    walk_in_or_shop: "Walk-in / Shop",
    shopkeeper_name: "Shopkeeper Name",
    optional: "Optional",
    add_items: "Add Items",
    selected_items: "Selected Items",
    no_items_added: "No items added yet",
    select_payment: "Select Payment",
    photo_optional: "Photo (Optional)",
    notes_optional: "Notes (Optional)",
    save_sale: "Save Sale",
    sale_saved: "Sale saved!",
    shop_matched: "Linked to existing shop",
    new_shop_walkin: "New / Walk-in shop",
    enter_shop_name: "Enter shop name",
    no_direct_sales: "No direct sales yet",
    my_direct_sales: "My Direct Sales",
    view_history: "View History",
    qty: "Qty",
    // Shop Type / Approval
    retailer: "Retailer",
    wholesaler: "Wholesaler",
    shop_type: "Shop Type",
    approval_status: "Approval Status",
    salesman_approved: "Salesman Approved",
    manager_approved: "Manager Approved",
    admin_approved: "Admin Approved",
    pending_approval: "Pending Approval",
    approve: "Approve",
    review_shops: "Review New Shops",
    no_pending_shops: "No new shops pending review",
    retailer_price: "Retailer Price",
    wholesaler_price: "Wholesaler Price",
    shop_type_locked: "Shop type is set by Manager",
    pick_shop_type: "Choose shop type",
    approved_by: "Approved by",
    submit_order: "Submit Order",
    order_sent: "Order Sent",
    awaiting_delivery: "Awaiting Delivery",
    price_hidden: "Pricing handled by company",
    // Danger Zone & moderation
    danger_zone: "Reset",
    danger_zone_warning: "Irreversible operations — proceed with caution.",
    block_user: "Block User",
    unblock_user: "Unblock",
    block_reason: "Reason for blocking",
    blocked: "Blocked",
    blocked_message: "Your account is blocked. Contact company.",
    deleted: "Deleted",
    restore: "Restore",
    trash: "Trash",
    backup_download: "Download Backup",
    backup_format_json: "JSON file",
    backup_format_csv: "CSV files (zip)",
    backup_format_both: "JSON + CSV (zip)",
    bulk_delete_orders: "Bulk Delete Orders",
    wipe_demo_data: "Wipe Demo Data",
    factory_reset: "Factory Reset",
    type_to_confirm: "Type to confirm",
    confirm_phone: "Confirm Super Admin phone",
    user_status_active: "Active",
    user_status_blocked: "Blocked",
    user_status_deleted: "Deleted",
    last_edited_by: "Last edited by",
    edit_order: "Edit Order",
    soft_delete: "Delete (recoverable)",
    confirm_delete: "Are you sure?",
    yes_delete: "Yes, Delete",
    cancel_delete: "Cancel",
    // Shopkeeper modify / cancel
    modify_order: "Edit Order",
    cancel_order: "Cancel Order",
    cancel_order_confirm: "Cancel this order?",
    yes_cancel: "Yes, Cancel",
    no_keep: "No, Keep",
    order_modified: "Order updated",
    order_cancelled: "Order cancelled",
    update_order: "Update Order",
    update_order_subtitle: "Add or remove items, then update.",
    // Clear History (shopkeeper)
    clear_history: "Clear History",
    clear_history_confirm: "Do you want to clear your order history?",
    history_cleared: "History cleared",
    // Top-level navigation groups
    nav_dashboard: "Dashboard",
    nav_orders: "Orders",
    nav_people: "People",
    nav_products: "Products",
    nav_stock: "Stock",
    nav_more: "More",
    outlets: "Outlets",
    // Stock by Depot (12B)
    depot: "Depot",
    depots: "Depots",
    category: "Category",
    categories: "Categories",
    receive_stock: "Receive Stock",
    receive_stock_today: "Stock Received Today",
    sold_today: "Sold Today",
    not_enough_stock: "Not enough stock",
    override_low_stock: "Override Low Stock",
    stock_history: "Stock History",
    pick_depot: "Select Depot",
    pick_category: "Select Category",
    pick_product: "Select Product",
    quantity_received: "Quantity Received",
    add_category: "Add Category",
    save_stock_entry: "Save",
    // Phase 12C: Bilingual data layer + auto-translate
    name_en: "Name (English)",
    name_ta: "Name (Tamil)",
    auto_translate: "Auto translate",
    auto_translating: "Translating…",
    translation_failed: "Translation failed",
    translation_done: "Translated",
    // Phase 12D: explicit roles
    role_retailer: "Retailer",
    role_wholesaler: "Wholesaler",
    role_outlets: "Outlets",
    retailers: "Retailers",
    wholesalers: "Wholesalers",
    // Phase A (Feb 2026): Complaint / Inquiry
    complaint_inquiry: "Complaint / Inquiry",
    contact_us: "Contact Us",
    call_company: "Call Company",
    company_support: "Tap to call our support team",
    // Best of the day
    best_sales_today: "Best Sales of the Day",
    rank: "Rank",
    // No-sale reasons (salesman)
    not_bought: "Not Bought",
    no_sale: "No Sale",
    reason: "Reason",
    reason_shop_closed: "Shop closed",
    reason_already_has_stock: "Already has our stock",
    reason_other_company: "Selling only other company products",
    reason_owner_absent: "Owner not available",
    reason_asking_credit: "Asking for credit",
    reason_price_issue: "Price issue",
    reason_other: "Reason not listed",
    enter_custom_reason: "Type reason…",
    no_sale_saved: "No-sale recorded",
    // Direct-sale assignee (manager)
    responsible_person: "Responsible Person",
    assign_to_self: "Myself (Manager)",
    assign_to_salesman: "Assign to Salesman",
    // Stock
    stock_received: "Stock Received",
    stock_balance: "Stock Balance",
    stock_history_label: "Depot Transfer History",
    // District / product drilldowns
    district_wise_sold: "District Wise Sold",
    product_wise_sold: "Product Wise Sold",
    top_product: "Top Product",
    top_salesman: "Top Salesman",
    total_shops: "Total Outlets",
    shop_visits: "Shop Visits",
    depot_stock: "Depot Stock",
    on_road_stock: "On-Road Stock",
    live_tracking: "Live Tracking",
    inactivity_alerts: "Inactivity Alerts",
    suspicious_visit: "Suspicious Visit",
    attendance: "Attendance",
    attendance_report: "Attendance Report",
    route_history: "Route History",
    download_excel: "Download Excel",
    select_person: "Select a person",
    chronological_stops: "Chronological Stops",
    no_data_for_day: "No data for selected day",
    gps_points: "GPS Points",
    stops: "Stops",
    person: "Person",
    from_date: "From Date",
    to_date: "To Date",
    present: "Present",
    absent: "Absent",
    partial: "Partial",
    tamil_name_missing: "Tamil name missing",
    tamil_name_required: "Tamil name is required",
    add_tamil_name: "Add Tamil name",
    boxes_sold: "Boxes Sold",
    not_bought: "Not Bought",
    depot_received: "Depot Received",
    depot_balance: "Depot Balance",
    stock_given: "Stock Given",
    night_tally: "Night Return / Tally",
    refresh: "Refresh",
    status: "Status",
    nav_command: "Home",
    live_tracking: "Live Tracking",
    print: "Print",
    print_report: "Print Report",
    // Add Shop (Field Onboarding — Apr 2026)
    add_shop: "Add Outlet",
    add_new_shop: "Add New Outlet",
    shop_type: "Outlet Type",
    owner_name: "Owner Name",
    shop_address: "Outlet Address",
    capture_location: "Capture Location",
    location_captured: "Location Captured",
    getting_location: "Getting location…",
    shop_name_ta: "Outlet Name (Tamil)",
    save_shop: "Save Outlet",
    shop_saved: "Outlet saved successfully",
    shop_exists: "Outlet already registered",
    phone_invalid_10: "Enter a valid 10-digit number",
    shop_name_required: "Outlet name is required",
    select_shop_type: "Select outlet type",
    no_shop_found: "No outlet found — contact salesman",
    // Phone-only login for outlets
    login_with_phone: "Login with phone",
    logging_in: "Logging in…",
    tap_to_continue: "Tap to continue",
    // Voice input
    voice_input: "Voice input",
    voice_language: "Voice language",
    listening: "Listening…",
    tap_mic_to_speak: "Tap mic to speak",
    voice_not_supported: "Voice input not supported on this device",
    mic_permission_denied: "Microphone permission denied. Please enable it in settings.",
    no_speech_detected: "No speech detected — tap mic and try again",
    voice_error: "Voice input failed — type instead",
    voice_hint: "Tap mic and speak. You can edit if needed.",
  },
  ta: {
    app_name: "GT ராயல் பார்ட்னர் ஆப்",
    // Auth
    welcome: "வணக்கம்",
    login: "உள்நுழை",
    phone: "தொலைபேசி எண்",
    pin: "4 இலக்க PIN போடுங்க",
    enter_phone: "தொலைபேசி எண் போடுங்க",
    invalid_login: "தவறான PIN",
    logout: "வெளியேறு",
    choose_language: "மொழியை தேர்வு செய்",
    // Common
    dashboard: "டாஷ்போர்டு",
    orders: "ஆர்டர்கள்",
    products: "பொருள்கள்",
    submit: "சமர்ப்பி",
    cancel: "ரத்து",
    confirm: "ஓகே",
    save: "சேமி",
    edit: "மாற்று",
    delete: "நீக்கு",
    back: "பின்",
    next: "அடுத்து",
    today: "இன்று",
    total: "மொத்தம்",
    amount: "தொகை",
    quantity: "எண்ணிக்கை",
    units: "பெட்டி",
    boxes: "பெட்டிகள்",
    box: "பெட்டி",
    total_boxes: "மொத்த பெட்டிகள்",
    pending_boxes: "பெண்டிங் பெட்டிகள்",
    delivered_boxes: "டெலிவரி முடிந்த பெட்டிகள்",
    stock_boxes: "ஸ்டாக் பெட்டிகள்",
    available_boxes: "இருக்கும் பெட்டிகள்",
    box_price: "பெட்டி விலை",
    boxes_sold: "விற்ற பெட்டிகள்",
    loading: "ஏற்றுகிறது…",
    yes: "ஆம்",
    no: "இல்லை",
    search: "தேடு",
    // Shopkeeper
    place_order: "ஆர்டர் போடு",
    my_orders: "என் ஆர்டர்கள்",
    profile: "என் தகவல்",
    select_products: "பொருள்களை தேர்வு செய்",
    add: "சேர்",
    remove: "எடு",
    cart: "வண்டி",
    payment_method: "பணம் கட்டும் முறை",
    cash: "காசு",
    upi: "UPI",
    pay_on_upi: "UPI யில் கட்டு",
    upi_id: "UPI ID",
    upload_screenshot: "ஸ்க்ரீன்ஷாட் (விரும்பினால்)",
    i_paid: "கட்டிட்டேன்",
    repeat_order: "மீண்டும் அதே ஆர்டர் போடு",
    no_orders: "ஆர்டர் இல்ல",
    order_placed: "ஆர்டர் சக்சஸ்!",
    order_date: "தேதி",
    items: "பொருள்கள்",
    status: "நிலை",
    // Salesman
    todays_orders: "இன்றைய ஆர்டர்கள்",
    delivered_today: "டெலிவரி முடிஞ்சது",
    pending: "பெண்டிங்",
    units_sold: "விற்ற பெட்டிகள்",
    sales: "விற்பனை",
    cash_collected: "காசு வசூல்",
    upi_collected: "UPI வசூல்",
    start_delivery: "டெலிவரி ஆரம்பி",
    mark_delivered: "டெலிவரி முடிஞ்சது",
    photo_proof: "போட்டோ அப்லோடு",
    take_photo: "போட்டோ எடு",
    enter_amount: "தொகை போடு",
    delivery_done: "டெலிவரி முடிஞ்சது",
    // Order statuses
    s_pending: "பெண்டிங்",
    s_assigned: "ஒதுக்கப்பட்டது",
    s_out_for_delivery: "வெளியே",
    s_delivered: "டெலிவரி முடிஞ்சது",
    s_cancelled: "ரத்தாக்கப்பட்டது",
    high_priority: "முக்கியம்",
    // Manager
    assigned: "ஒதுக்கப்பட்டது",
    assign: "ஒதுக்கு",
    assign_salesman: "சேல்ஸ்மேன் ஒதுக்கு",
    salesmen: "சேல்ஸ்மேன்கள்",
    reassign: "மீண்டும் ஒதுக்கு",
    salesman_performance: "சேல்ஸ்மேன் செயல்திறன்",
    // Management
    company_performance: "நிறுவன செயல்திறன்",
    district_performance: "மாவட்ட செயல்திறன்",
    cash_vs_upi: "காசு vs UPI",
    last_7_days: "கடந்த 7 நாட்கள்",
    // Admin (English-leaning since admin is technical)
    users: "பயனர்கள்",
    districts: "மாவட்டங்கள்",
    beats: "பீட்கள்",
    bulk_upload: "பல்க் அப்லோடு",
    upi_pending: "UPI பெண்டிங்",
    verify: "சரிபார்",
    add_user: "பயனர் சேர்",
    add_product: "பொருள் சேர்",
    add_district: "மாவட்டம் சேர்",
    name: "பெயர்",
    role: "பதவி",
    district: "மாவட்டம்",
    region: "பகுதி",
    price: "விலை",
    sku: "SKU",
    shop_name: "கடை பெயர்",
    address: "முகவரி",
    upload_csv: "CSV அப்லோடு",
    paid: "கட்டியாச்சு",
    cash_to_collect: "காசு வசூலிக்கணும்",
    payment_status: "பணம் நிலை",
    your_name: "உங்க பெயர்",
    welcome_back: "வரவேற்கிறோம்",
    not_registered: "இந்த நம்பர் ரெஜிஸ்டர் ஆகல",
    close: "மூடு",
    offer: "ஆஃபர்",
    scheme: "ஸ்கீம்",
    popups: "பாப்அப்ஸ்",
    filters: "வடிகட்டிகள்",
    clear_filters: "அழி",
    apply: "செயல்படுத்து",
    all: "எல்லாம்",
    date_range: "தேதி",
    from: "முதல்",
    to: "வரை",
    map_view: "வரைபட காட்சி",
    route_map: "ரூட் மேப்",
    no_locations: "இடங்கள் இல்ல",
    notifications: "அறிவிப்புகள்",
    no_notifications: "அறிவிப்பு இல்ல",
    mark_all_read: "எல்லாம் படிச்சாச்சு",
    audit_logs: "ஆடிட் பதிவுகள்",
    assignment_history: "ஒதுக்கீடு வரலாறு",
    offline: "ஆஃப்லைன்",
    pending_sync: "சின்க் காத்திருக்கு",
    synced: "சின்க் ஆச்சு",
    // Direct Sale
    direct_sale: "நேரடி விற்பனை",
    new_direct_sale: "புதிய நேரடி விற்பனை",
    sales_history: "விற்பனை வரலாறு",
    walk_in: "வாக்-இன்",
    walk_in_or_shop: "வாக்-இன் / கடை",
    shopkeeper_name: "கடைக்காரர் பெயர்",
    optional: "விரும்பினால்",
    add_items: "பொருள் சேர்",
    selected_items: "தேர்ந்தெடுத்தவை",
    no_items_added: "பொருள் சேர்க்கல",
    select_payment: "பணம் முறை",
    photo_optional: "போட்டோ (விரும்பினால்)",
    notes_optional: "குறிப்பு (விரும்பினால்)",
    save_sale: "விற்பனை சேமி",
    sale_saved: "விற்பனை சேமிச்சாச்சு!",
    shop_matched: "ஏற்கனவே உள்ள கடை",
    new_shop_walkin: "புதிய / வாக்-இன் கடை",
    enter_shop_name: "கடை பெயர் போடுங்க",
    no_direct_sales: "நேரடி விற்பனை இல்ல",
    my_direct_sales: "என் நேரடி விற்பனை",
    view_history: "வரலாறு பார்",
    qty: "எண்ணிக்கை",
    // Shop Type / Approval
    retailer: "சில்லறை",
    wholesaler: "மொத்த வியாபாரி",
    shop_type: "கடை வகை",
    approval_status: "அனுமதி நிலை",
    salesman_approved: "சேல்ஸ்மேன் ஒப்புதல்",
    manager_approved: "மேனேஜர் ஒப்புதல்",
    admin_approved: "அட்மின் ஒப்புதல்",
    pending_approval: "ஒப்புதல் காத்திருக்கிறது",
    approve: "ஒப்புதல்",
    review_shops: "புதிய கடைகளை பார்",
    no_pending_shops: "புதிய கடை இல்ல",
    retailer_price: "சில்லறை விலை",
    wholesaler_price: "மொத்த விலை",
    shop_type_locked: "மேனேஜர் தீர்மானிக்கிறார்",
    pick_shop_type: "கடை வகையை தேர்வு செய்",
    approved_by: "ஒப்புதல் தந்தவர்",
    submit_order: "ஆர்டர் அனுப்பு",
    order_sent: "ஆர்டர் அனுப்பிட்டோம்",
    awaiting_delivery: "டெலிவரி காத்திருக்கிறது",
    price_hidden: "விலையை நிறுவனம் கையாளும்",
    // Danger Zone & moderation
    danger_zone: "மீட்டமை",
    danger_zone_warning: "திரும்ப முடியாத செயல்கள் — கவனமாக தொடரவும்.",
    block_user: "பயனரை பிளாக் செய்",
    unblock_user: "அன்பிளாக்",
    block_reason: "பிளாக் காரணம்",
    blocked: "பிளாக் ஆச்சு",
    blocked_message: "உங்கள் அக்கவுண்ட் பிளாக் செய்யப்பட்டுள்ளது. கம்பெனியை தொடர்பு கொள்ளவும்.",
    deleted: "நீக்கப்பட்டது",
    restore: "மீட்டமை",
    trash: "குப்பை",
    backup_download: "பேக்கப் பதிவிறக்கு",
    backup_format_json: "JSON கோப்பு",
    backup_format_csv: "CSV கோப்புகள் (zip)",
    backup_format_both: "JSON + CSV (zip)",
    bulk_delete_orders: "ஆர்டர்களை மொத்தமாக நீக்கு",
    wipe_demo_data: "டெமோ டேட்டாவை அழி",
    factory_reset: "ஃபேக்டரி ரீசெட்",
    type_to_confirm: "உறுதிப்படுத்த இதை டைப் செய்",
    confirm_phone: "சூப்பர் அட்மின் தொலைபேசியை உறுதிப்படுத்து",
    user_status_active: "செயலில்",
    user_status_blocked: "பிளாக்",
    user_status_deleted: "நீக்கப்பட்டது",
    last_edited_by: "கடைசியாக மாற்றியவர்",
    edit_order: "ஆர்டர் மாற்று",
    soft_delete: "நீக்கு (மீட்க முடியும்)",
    confirm_delete: "உறுதியா?",
    yes_delete: "ஆம், நீக்கு",
    cancel_delete: "ரத்து",
    // Shopkeeper modify / cancel
    modify_order: "ஆர்டர் மாற்று",
    cancel_order: "ஆர்டர் ரத்து",
    cancel_order_confirm: "இந்த ஆர்டரை ரத்து செய்யவா?",
    yes_cancel: "ஆம், ரத்து செய்",
    no_keep: "வேண்டாம், வைக்கவும்",
    order_modified: "ஆர்டர் மாற்றப்பட்டது",
    order_cancelled: "ஆர்டர் ரத்தாக்கப்பட்டது",
    update_order: "ஆர்டர் புதுப்பி",
    update_order_subtitle: "பொருட்களை சேர்க்க/நீக்க, பின்பு புதுப்பிக்கவும்.",
    // Clear History (shopkeeper)
    clear_history: "ஹிஸ்டரி நீக்கு",
    clear_history_confirm: "உங்கள் ஆர்டர் ஹிஸ்டரியை நீக்கவா?",
    history_cleared: "ஹிஸ்டரி நீக்கப்பட்டது",
    // Top-level navigation groups
    nav_dashboard: "டாஷ்போர்டு",
    nav_orders: "ஆர்டர்கள்",
    nav_people: "மக்கள்",
    nav_products: "பொருட்கள்",
    nav_stock: "ஸ்டாக்",
    nav_more: "மேலும்",
    outlets: "கடைகள்",
    // Stock by Depot (12B)
    depot: "டிப்போ",
    depots: "டிப்போக்கள்",
    category: "வகை",
    categories: "வகைகள்",
    receive_stock: "ஸ்டாக் வாங்கு",
    receive_stock_today: "இன்று வந்த ஸ்டாக்",
    sold_today: "இன்று விற்றது",
    not_enough_stock: "ஸ்டாக் போதவில்லை",
    override_low_stock: "குறைந்த ஸ்டாக் கடந்து செல்",
    stock_history: "ஸ்டாக் வரலாறு",
    pick_depot: "டிப்போ தேர்ந்தெடு",
    pick_category: "வகை தேர்ந்தெடு",
    pick_product: "பொருள் தேர்ந்தெடு",
    quantity_received: "வந்த அளவு",
    add_category: "வகை சேர்",
    save_stock_entry: "சேமி",
    // Phase 12C: Bilingual data layer + auto-translate
    name_en: "பெயர் (ஆங்கிலம்)",
    name_ta: "பெயர் (தமிழ்)",
    auto_translate: "தானாக மொழிபெயர்",
    auto_translating: "மொழிபெயர்க்கிறேன்…",
    translation_failed: "மொழிபெயர்ப்பு தோல்வி",
    translation_done: "மொழிபெயர்க்கப்பட்டது",
    // Phase 12D: explicit roles
    role_retailer: "சில்லறை",
    role_wholesaler: "மொத்த",
    role_outlets: "கடைகள்",
    retailers: "சில்லறை கடைகள்",
    wholesalers: "மொத்த கடைகள்",
    // Phase A (Feb 2026): Complaint / Inquiry
    complaint_inquiry: "புகார் / விசாரணை",
    contact_us: "எங்களை தொடர்பு கொள்ளுங்க",
    call_company: "கம்பெனியை கூப்பிடு",
    company_support: "கஸ்டமர் கேர் கூப்பிட இதை தட்டுங்க",
    // Best of the day
    best_sales_today: "இன்றைய சிறந்த விற்பனையாளர்கள்",
    rank: "தரம்",
    // No-sale reasons
    not_bought: "வாங்கல",
    no_sale: "விற்பனை இல்ல",
    reason: "காரணம்",
    reason_shop_closed: "கடை மூடியிருக்கு",
    reason_already_has_stock: "ஏற்கனவே நம் ஸ்டாக் இருக்கு",
    reason_other_company: "வேற கம்பெனி மட்டுமே வைக்கிறாங்க",
    reason_owner_absent: "உரிமையாளர் இல்ல",
    reason_asking_credit: "கடன் கேக்கிறாங்க",
    reason_price_issue: "விலை பிரச்சினை",
    reason_other: "காரணம் பட்டியலில் இல்ல",
    enter_custom_reason: "காரணத்தை டைப் செய்…",
    no_sale_saved: "பதிவு ஆச்சு",
    // Direct-sale assignee (manager)
    responsible_person: "பொறுப்பானவர்",
    assign_to_self: "நானே (மேனேஜர்)",
    assign_to_salesman: "சேல்ஸ்மேனுக்கு கொடு",
    // Stock
    stock_received: "வந்த ஸ்டாக்",
    stock_balance: "இருக்கும் ஸ்டாக்",
    stock_history_label: "டிப்போ ஸ்டாக் வரலாறு",
    // District / product drilldowns
    district_wise_sold: "மாவட்ட வாரியா விற்றது",
    product_wise_sold: "பொருள் வாரியா விற்றது",
    top_product: "முதன்மை பொருள்",
    top_salesman: "முதன்மை சேல்ஸ்மேன்",
    total_shops: "மொத்த கடைகள்",
    shop_visits: "கடை பார்வை",
    depot_stock: "டிப்போ ஸ்டாக்",
    on_road_stock: "ரோடு ஸ்டாக்",
    live_tracking: "நேரடி கண்காணிப்பு",
    inactivity_alerts: "செயல்பாடற்ற எச்சரிக்கைகள்",
    suspicious_visit: "சந்தேகமான வருகை",
    attendance: "வருகை",
    attendance_report: "வருகை அறிக்கை",
    route_history: "வழி வரலாறு",
    download_excel: "Excel பதிவிறக்கம்",
    select_person: "ஒருவரை தேர்ந்தெடுங்கள்",
    chronological_stops: "காலவரிசை நிறுத்தங்கள்",
    no_data_for_day: "இந்த நாளுக்கு தரவு இல்ல",
    gps_points: "GPS பாயிண்ட்கள்",
    stops: "நிறுத்தங்கள்",
    person: "நபர்",
    from_date: "முதல் தேதி",
    to_date: "கடைசி தேதி",
    present: "வந்தவர்கள்",
    absent: "வராதவர்கள்",
    partial: "பகுதியளவு",
    tamil_name_missing: "தமிழ் பெயர் இல்ல",
    tamil_name_required: "தமிழ் பெயர் கட்டாயம்",
    add_tamil_name: "தமிழ் பெயர் சேர்",
    boxes_sold: "விற்ற பெட்டிகள்",
    not_bought: "வாங்கல",
    depot_received: "டிப்போ வந்த ஸ்டாக்",
    depot_balance: "டிப்போ சில்லறை",
    stock_given: "ஸ்டாக் கொடுத்தது",
    night_tally: "இரவு கணக்கு",
    refresh: "புதுப்பி",
    status: "நிலை",
    nav_command: "முகப்பு",
    live_tracking: "நேரலை கண்காணிப்பு",
    print: "அச்சிடு",
    print_report: "அறிக்கை அச்சிடு",
    // Add Shop (Field Onboarding — Apr 2026)
    add_shop: "கடை சேர்",
    add_new_shop: "புது கடை சேர்",
    shop_type: "கடை வகை",
    owner_name: "உரிமையாளர் பெயர்",
    shop_address: "கடை முகவரி",
    capture_location: "இடம் பிடி",
    location_captured: "இடம் சேமிச்சாச்சு",
    getting_location: "இடம் எடுக்குது…",
    shop_name_ta: "கடை பெயர் (தமிழ்)",
    save_shop: "கடை சேமி",
    shop_saved: "கடை சேமிச்சாச்சு",
    shop_exists: "இந்த கடை ஏற்கனவே இருக்கு",
    phone_invalid_10: "சரியான 10-இலக்க எண் போடுங்க",
    shop_name_required: "கடை பெயர் கட்டாயம்",
    select_shop_type: "கடை வகை தேர்ந்தெடு",
    no_shop_found: "கடை கிடைக்கல — Salesman-ஐ தொடர்பு கொள்ளுங்க",
    // Phone-only login for outlets
    login_with_phone: "எண்ணோட நுழை",
    logging_in: "நுழைகிறது…",
    tap_to_continue: "தொட்டு தொடருங்க",
    // Voice input
    voice_input: "குரல் உள்ளீடு",
    voice_language: "குரல் மொழி",
    listening: "கேக்குது…",
    tap_mic_to_speak: "மைக் தொட்டு பேசுங்க",
    voice_not_supported: "இந்த device-ல குரல் உள்ளீடு வேலை செய்யாது",
    mic_permission_denied: "மைக் அனுமதி இல்ல. Settings-ல allow பண்ணுங்க.",
    no_speech_detected: "குரல் கேக்கல — மீண்டும் தொட்டு பேசுங்க",
    voice_error: "குரல் உள்ளீடு தோல்வி — தட்டச்சு செய்யுங்க",
    voice_hint: "மைக் தொட்டு பேசுங்க. வேணும்னா திருத்தலாம்.",
  },
};

export const t = (lang, key) => {
  const dict = translations[lang] || translations.en;
  return dict[key] || translations.en[key] || key;
};

// Phase 12C: pick best display name for an entity (product/shop/category/area...)
// Returns name_ta when lang='ta' (and present), else name_en, else legacy `name`.
export const displayName = (item, lang) => {
  if (!item) return "";
  if (typeof item === "string") return item;
  if (lang === "ta" && item.name_ta) return item.name_ta;
  return item.name_en || item.name || "";
};
